import { IOffer } from "@nju/data-access-portal-offers";
import { sortByOfferPrice } from "./sortByOfferPrice";

interface IFilterPromoRoamingPackagesProps {
  offers: IOffer[];
  id: "DATA_PACKAGE" | "VOICE_PACKAGE";
  promoRoamingZones: string[] | null | undefined;
}

export function filterPromoRoamingPackages({
  offers,
  id,
  promoRoamingZones,
}: IFilterPromoRoamingPackagesProps) {
  return offers
    .filter((offer) => {
      return (
        offer.visibility &&
        offer.category === "ROAMING" &&
        offer.productSpecificationType === "PRODUCT" &&
        offer.productSpecificationId === id &&
        promoRoamingZones?.includes(offer.zone ?? "")
      );
    })
    .sort(sortByOfferPrice);
}
